<!--
 * @Description: 专题页
 * @Author: wuxuebing
 * @Date: 2024-07-10 08:49:42
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-11 14:18:37
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\topic-page-management\topic-page\index.vue
-->

<template>
	<div class="h100 audit">
		<filter-layout @search="doSearch" @reset="doRefresh" v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchForm" label-width="120px" :model="searchObj">
					<el-form-item label="归属单位：" prop="belongUnit">
						<el-input :placeholder="'请输入内容'" clearable v-model="searchObj.belongUnit" size="small"></el-input>
					</el-form-item>
					<el-form-item label="专题页模板名称：" prop="temName" label-width="140px">
						<el-input :placeholder="'请输入'" clearable v-model="searchObj.temName" size="small"></el-input>
					</el-form-item>
					<el-form-item label="状态：" prop="status">
						<el-select v-model="searchObj.status" placeholder="请选择" clearable size="small">
							<el-option v-for="(item, index) in statusArr" :key="index" :label="item.sname" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<!-- 头部按钮 -->
				<div class="content-header" v-if="!routeQuery">
					<div class="title"></div>
					<div class="btnGroups">
						<el-button type="primary" class="btn-blue ml10" size="small" @click="handleTools('add')">新增</el-button>

						<el-button size="small" class="btn-blue" icon="el-icon-refresh" type="primary" @click="doRefresh"></el-button>
					</div>
				</div>
				<div class="operation-container w-table-layout w-table-page" v-if="!routeQuery">
					<div class="w-table-content" v-show="tableShow">
						<vxe-table
							:data="tableObj.tableData"
							:loading="tableObj.loading"
							:border="tableObj.border"
							:resizable="tableObj.resizable"
							:size="tableObj.size"
							:height="tableObj.height"
							highlight-current-row
							highlight-hover-row
							show-overflow="tooltip"
							v-show="tableShow"
							show-header-overflow="tooltip"
						>
							<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
							<vxe-table-column field="belongUnit" title="归属单位" align="center" width="220" show-overflow-tooltip></vxe-table-column>
							<vxe-table-column field="tenantTypeName" title="企业类型" align="center" width="100"> </vxe-table-column>
							<vxe-table-column field="tenantTagName" title="标签" align="left" width="180"> </vxe-table-column>
							<vxe-table-column field="pageUrl" title="专题页路径" align="left" min-width="180"> </vxe-table-column>
							<vxe-table-column field="temName" title="专题页模板" align="center" width="120"></vxe-table-column>
							<vxe-table-column field="status" title="状态" align="center" width="90">
								<template v-slot="{ row }">
									{{ row.status == 0 ? '禁用' : '启用' }}
								</template>
							</vxe-table-column>
							<vxe-table-column field="createUser" title="创建人" align="center" width="90"></vxe-table-column>
							<vxe-table-column field="createDate" title="创建时间" align="center" width="160"> </vxe-table-column>

							<vxe-table-column title="操作" width="270" align="center">
								<template v-slot="{ row }">
									<el-button
										type="success"
										size="small"
										round
										plain
										class="table-btn"
										icon="el-icon-search"
										@click="handleTools('view', row)"
									>
										查看
									</el-button>

									<el-button
										type="success"
										size="small"
										round
										plain
										class="table-btn"
										icon="el-icon-edit"
										@click="handleTools('edit', row)"
									>
										编辑
									</el-button>

									<el-button
										type="primary"
										size="small"
										round
										plain
										class="table-btn"
										icon="el-icon-document"
										@click="handleTools('content', row)"
									>
										内容管理
									</el-button>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<vxe-pager
							size="mini"
							:current-page="searchObj.currentPage"
							:page-size="searchObj.pageSize"
							:total="searchObj.totalResult"
							class="text-center"
							:page-sizes="[10, 20, 50, 100]"
							:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
							@page-change="handlePageChange"
						>
						</vxe-pager>
					</div>
				</div>
			</template>
		</filter-layout>
		<div class="check-setting" v-else-if="routeQuery == 'content'">
			<!-- 内容管理 -->
			<content-management @close="doSearch"></content-management>
		</div>

		<add-dialog v-if="showDialog" ref="add_dialog" @closeDialog="doSearch('1')"></add-dialog>
	</div>
</template>

<script>
import * as API from 'api/modules/topicPage.js'
import { mapState } from 'vuex'

import addDialog from './components/add-dialog.vue'
import ContentManagement from './components/content-management.vue'

export default {
	data() {
		return {
			showFilter: true,
			searchObj: {
				belongUnit: '', // 归属单位
				temName: '', // 专题页模板名称
				status: '', // 状态 0禁用，1启用
				currentPage: 1, // 当前页码
				pageSize: 10, // 当前每页条数
				totalResult: 0
			},
			// 表格对象
			tableObj: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			},
			searchToggle: true, //筛选控制
			tableShow: true, //表格显隐控制
			showDialog: false // 弹框显隐控制
		}
	},
	components: {
		addDialog,
		ContentManagement
	},
	mounted() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchObj')) {
				this.searchObj = JSON.parse(this.$getSessionItem('searchObj'))
				// 移除 避免污染
				this.$removeSessionItem('searchObj')
			}
			if (this.$getSessionItem('pageInfo')) {
				// 移除 避免污染
				this.$removeSessionItem('pageInfo')
			}
		}
		this.doSearch()
	},
	methods: {
		// 查询专题页列表
		doSearch(page) {
			if (page) {
				this.searchObj.pageSize = 10
				this.searchObj.currentPage = 1
			}
			let params = {
				size: this.searchObj.pageSize, // 当前每页条数
				current: this.searchObj.currentPage, // 当前页码
				belongUnit: this.searchObj.belongUnit, // 归属单位

				temName: this.searchObj.temName, // 专题页模板名称
				status: this.searchObj.status //专题页模板名称
			}
			this.tableObj.loading = true
			API.getTopicPages(params)
				.then((res) => {
					this.tableObj.loading = false
					if (res.operationCode === 1) {
						this.tableObj.tableData = res.data.records
						this.searchObj.totalResult = parseInt(res.data.total)
					}
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		//刷新/重置
		doRefresh() {
			this.searchObj.pageSize = 10

			//   归属单位数据清空
			this.searchObj.belongUnit = ''
			// 专题页模板名称数据清空
			this.searchObj.temName = ''
			//   状态数据清空
			this.searchObj.status = ''
			this.doSearch('1')
		},
		// 右侧操作
		handleTools(type, row) {
			switch (type) {
				case 'add':
				case 'edit':
				case 'view':
					this.showDialog = true
					setTimeout(() => {
						this.$refs.add_dialog && this.$refs.add_dialog.openClick(type, row)
					}, 200)
					break

				default:
					let checkObj = Object.assign({}, row)
					// 存值
					this.$setSessionItem('pageInfo', JSON.stringify(checkObj))
					// 存值
					this.$setSessionItem('searchObj', JSON.stringify(this.searchObj))
					this.$router.push({
						path: '/topic-page',
						query: {
							type: 'content'
						}
					})
			}
		},
		// 切换筛选状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 切换分页
		handlePageChange({ currentPage, pageSize }) {
			this.searchObj.currentPage = currentPage
			this.searchObj.pageSize = pageSize
			this.doSearch()
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', { isBack: (state) => state.isBack }),

		statusArr() {
			let arr = [
				{
					value: '0',
					sname: '禁用'
				},
				{
					value: '1',
					sname: '启用'
				}
			]
			return arr
		}
	}
}
</script>
<style scoped lang="less">
.content-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	.title {
		padding-left: 10px;
		border-left: 4px solid #2671cc;
		font-size: 14px;
		color: #202020;
	}
	.blue {
		font-size: 18px;
		color: #2671cc;
	}
}
</style>
